import React, { useState } from 'react';
import moment from 'moment';
import { Button, makeStyles, Grid, Chip, TextField, Divider } from '@material-ui/core';
import { Dialog, Panel, Typography } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setAppealRequestStatus, getStorageFileUri } from 'store/firebase';
import { useAlert, useReduxDispatch, useReduxSelector } from 'store/hooks';
import { fetchAppealRequests } from 'store/appealRequest';
import { STATUSES } from 'config/leaveStatus';

const useStyles = makeStyles((theme) => ({
  infoContainer: {
    display: 'flex',
    alignItems: 'center',
    height: 30,
  },
}));

const STATUS_KEYS = {};

// eslint-disable-next-line no-return-assign
STATUSES.forEach((e) => (STATUS_KEYS[e.id] = e.label));

const TransactionDetail = ({ selected, setSelectedLeave, setDraftEditLeave, setSelected }) => {
  const [openRejectmodal, setOpenRejectmodal] = useState();
  const [rejectionMessage, setRejectionMessage] = useState('');
  const classes = useStyles();
  const { alertWaiting, alertSuccess, alertError } = useAlert();
  const getPendingRequest = useReduxDispatch(fetchAppealRequests);
  const userAccount = useReduxSelector((state) => state.account.data);
  const hasFullAccess = Array.isArray(userAccount.access) && userAccount.access.includes('appeals');

  const setRequesStatus = async (item, status) => {
    try {
      alertWaiting();

      const payload = {
        employeeUid: item.uid,
        id: item.id,
        status,
        ...(status === 'rejected' ? { rejectionMessage } : {}),
      };

      await setAppealRequestStatus({ ...payload });

      alertSuccess();
      setOpenRejectmodal(false);
      setRejectionMessage('');
      getPendingRequest();
      let seletedData = await getPendingRequest();
      seletedData = seletedData.payload.find((updatedItem) => updatedItem.id === item.id);
      setSelected(seletedData);
    } catch (err) {
      alertError(err?.message || err);
    }
  };

  return (
    <>
      <Grid item xs={12} md={6}>
        <Panel>
          {selected.status === 'approved' && selected.category === 'leave' && hasFullAccess && (
            <div
              style={{
                width: '100%',
                textAlign: 'right',
                marginBottom: 8,
              }}
            >
              <Chip
                clickable
                size="small"
                label={'Ubah Cuti'}
                icon={
                  <FontAwesomeIcon
                    icon="edit"
                    size="sm"
                    style={{
                      marginRight: 5,
                    }}
                  />
                }
                variant="outlined"
                color="secondary"
                style={{
                  marginRight: 6,
                  marginBottom: 8,
                  padding: 8,
                }}
                onClick={() => {
                  setSelectedLeave(selected);
                  setDraftEditLeave(selected);
                }}
              />
            </div>
          )}
          <div className={classes.infoContainer}>
            <Typography variant="body1" type="bold" style={{ width: 200 }}>
              Nama
            </Typography>
            <Typography variant="body1">{selected?.employee?.fullname}</Typography>
          </div>
          <div className={classes.infoContainer}>
            <Typography variant="body1" type="bold" style={{ width: 200 }}>
              NIP
            </Typography>
            <Typography variant="body1">{selected?.nip}</Typography>
          </div>
          <div className={classes.infoContainer}>
            <Typography variant="body1" type="bold" style={{ width: 200 }}>
              Posisi
            </Typography>
            <Typography variant="body1">{selected?.employee.position || '-'}</Typography>
          </div>

          <div className={classes.infoContainer}>
            <Typography variant="body1" type="bold" style={{ width: 200 }}>
              Divisi
            </Typography>
            <Typography variant="body1">{selected?.employee.division || '-'}</Typography>
          </div>

          <div className={classes.infoContainer}>
            <Typography variant="body1" type="bold" style={{ width: 200 }}>
              Kehadiran yang disanggah
            </Typography>
            <Typography variant="body1">
              {selected.oldEntryTime
                ? `${moment(selected.oldEntryTime).format('DD/MM/YYYY HH:mm')} — ${
                    selected.oldExitTime
                      ? moment(selected.oldExitTime).format('DD/MM/YYYY HH:mm')
                      : 'Tidak absen pulang'
                  }`
                : 'Tidak hadir'}
            </Typography>
          </div>
          <div className={classes.infoContainer}>
            <Typography variant="body1" type="bold" style={{ width: 200 }}>
              Koreksi yang diajukan
            </Typography>
            <Typography variant="body1">
              {selected.newEntryTime
                ? `${moment(selected.newEntryTime).format('DD/MM/YYYY HH:mm')} — ${
                    selected.newExitTime
                      ? moment(selected.newExitTime).format('DD/MM/YYYY HH:mm')
                      : 'Tidak absen pulang'
                  }`
                : 'Tidak hadir'}
            </Typography>
          </div>
          <div className={classes.infoContainer}>
            <Typography variant="body1" type="bold" style={{ width: 200 }}>
              Keterangan
            </Typography>
            <Typography variant="body1">{selected?.information || '-'}</Typography>
          </div>
          <div className={classes.infoContainer}>
            <Typography variant="body1" type="bold" style={{ width: 200 }}>
              Lampiran
            </Typography>
            {selected?.file ? (
              <Chip
                clickable
                size="small"
                label={'Download'}
                icon={
                  <FontAwesomeIcon
                    icon="download"
                    size="sm"
                    style={{
                      marginRight: 5,
                    }}
                  />
                }
                variant="outlined"
                color="secondary"
                style={{
                  marginRight: 6,
                  marginBottom: 8,
                  padding: 8,
                }}
                onClick={async () => {
                  const uri = await getStorageFileUri({ category: 'appeal', ...selected });
                  window.open(uri, '_blank');
                }}
              />
            ) : (
              <Typography variant="body1" style={{ fontStyle: 'italic' }}>
                Tidak ada lampiran
              </Typography>
            )}
          </div>
          <div className={classes.infoContainer}>
            <Typography variant="body1" type="bold" style={{ width: 200 }}>
              Status
            </Typography>
            <Typography variant="body1">
              {selected?.status ? STATUS_KEYS[selected?.status] || '' : ''}
            </Typography>
          </div>
          {selected?.changeStatusMessage && (
            <div className={classes.infoContainer}>
              <Typography variant="body1" type="bold" style={{ width: 200 }}>
                Alasan Perubahan Status
              </Typography>
              <Typography variant="body1">{selected?.changeStatusMessage || '-'}</Typography>
            </div>
          )}
          {selected?.status === 'rejected' && !selected?.changeStatusMessage && (
            <div className={classes.infoContainer}>
              <Typography variant="body1" type="bold" style={{ width: 200 }}>
                Alasan Penolakan
              </Typography>
              <Typography variant="body1">{selected?.rejectionMessage || '-'}</Typography>
            </div>
          )}

          {selected?.status === 'pending' && hasFullAccess && (
            <div style={{ marginTop: 16 }}>
              <Button
                variant="contained"
                onClick={() => setOpenRejectmodal(true)}
                color="error"
                style={{ marginRight: 16 }}
              >
                Tolak
              </Button>
              <Button
                variant="contained"
                onClick={() => setRequesStatus(selected, 'approved')}
                color="primary"
              >
                {hasFullAccess ? 'Setujui' : 'Teruskan ke HR'}
              </Button>
            </div>
          )}
        </Panel>
      </Grid>
      <Dialog
        fullWidth
        open={openRejectmodal}
        onClose={() => setOpenRejectmodal()}
        title={'Tolak Sanggahan'}
        action={{
          label: 'Reject',
          onClick: () => setRequesStatus(selected, 'rejected'),
          props: { color: 'error' },
        }}
      >
        <Grid container>
          <Grid item xs={6}>
            <div className={classes.infoContainer}>
              <Typography variant="body1" type="bold" style={{ width: 100 }}>
                Nama
              </Typography>
              <Typography variant="body1">{selected?.employee?.fullname}</Typography>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.infoContainer}>
              <Typography variant="body1" type="bold" style={{ width: 100 }}>
                NIP
              </Typography>
              <Typography variant="body1">{selected?.nip}</Typography>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.infoContainer}>
              <Typography variant="body1" type="bold" style={{ width: 100 }}>
                Posisi
              </Typography>
              <Typography variant="body1">{selected?.employee?.position || '-'}</Typography>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.infoContainer}>
              <Typography variant="body1" type="bold" style={{ width: 100 }}>
                Divisi
              </Typography>
              <Typography variant="body1">{selected?.employee?.division || '-'}</Typography>
            </div>
          </Grid>
          <Divider />
          <div className={classes.infoContainer}>
            <Typography variant="body1" type="bold" style={{ width: 200 }}>
              Kehadiran yang disanggah
            </Typography>
            <Typography variant="body1">
              {selected.oldEntryTime
                ? `${moment(selected.oldEntryTime).format('DD/MM/YYYY HH:mm')} - ${
                    selected.oldExitTime
                      ? moment(selected.oldExitTime).format('DD/MM/YYYY HH:mm')
                      : 'Tidak absen pulang'
                  }`
                : 'Tidak hadir'}
            </Typography>
          </div>
          <div className={classes.infoContainer}>
            <Typography variant="body1" type="bold" style={{ width: 200 }}>
              Koreksi yang diajukan
            </Typography>
            <Typography variant="body1">
              {selected.newEntryTime
                ? `${moment(selected.newEntryTime).format('DD/MM/YYYY HH:mm')} - ${
                    selected.newExitTime
                      ? moment(selected.newExitTime).format('DD/MM/YYYY HH:mm')
                      : 'Tidak absen pulang'
                  }`
                : 'Tidak hadir'}
            </Typography>
          </div>
          <Grid item xs={12}>
            <TextField
              style={{ width: '100%', marginTop: 16 }}
              multiline
              maxRows={4}
              variant="outlined"
              aria-label="empty textarea"
              label="Alasan Penolakan"
              onChange={(event) => setRejectionMessage(event.target.value)}
            />
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default TransactionDetail;
